import { UserAuthentication } from './actionTypes';
import { doRequest } from '../../utils';

const requestingIsLoggedIn = () => ({
    type: UserAuthentication.REQUEST_IS_LOGGED_IN,
});

const receiveIsLoggedIn = (usersResponse) => ({
    type: UserAuthentication.RECEIVE_IS_LOGGED_IN,
    usersResponse,
});

const fetchIsLoggedIn = () => {
    const url = '/frontend-home/service/users/isloggedin';
    return (dispatch) => {
        dispatch(requestingIsLoggedIn());
        return doRequest(url, { method: 'POST' })
            .then((response) => response.json())
            .then((usersResponse) => {
                return dispatch(receiveIsLoggedIn(usersResponse));
            });
    };
};

const shouldFetchIsLoggedIn = ({ initial, isFetching }) => {
    return initial && !isFetching;
};

export const isLoggedIn = () => {
    return (dispatch, getState) => {
        const { userAuthentication } = getState();
        if (shouldFetchIsLoggedIn(userAuthentication)) {
            return dispatch(fetchIsLoggedIn());
        } else {
            return Promise.resolve();
        }
    };
};
